import styles from './Tooltip.module.scss'

const CustomTooltip = ({ periodCurrent, periodPrevious, isVisible }) => {
  if (isVisible) {
    return (
      <div className={styles.tooltip}>
        <div className={styles.row}>
          <span className={styles.label}>Current period</span>
          <span className={styles.value}>{periodCurrent}</span>
        </div>
        <div className={styles.row}>
          <span className={styles.label}>Previous period</span>
          <span className={styles.value}>{periodPrevious}</span>
        </div>
      </div>
    )
  }
  return null
}

export default CustomTooltip
